import * as o from "react";
import e from "../lib/IconBase.es.js";
import t from "../defs/Warning.es.js";
const r = o.forwardRef((n, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...n, weights: t }));
r.displayName = "WarningIcon";
const c = r;
export {
  c as Warning,
  r as WarningIcon
};
